module.exports = __webpack_public_path__ + "static/img/微信图片_20200430092314.317873b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/微信图片_20200430092314.jpg
// module id = qRox
// module chunks = 14